/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SearchIcon from "@mui/icons-material/Search";

import {
  Button,
  Card,
  CardContent,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import { Add as AddIcon } from "@mui/icons-material";
import { Box } from "@mui/system";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import AssignedTasksFilter from "./assignedTasksFilter";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function AllTasks({
  auths,
  tasks,
  jobs,
  apUsers,
  onUpdateStatus,
  setFilter,
  filteredData,
  searchKeyword,
  loader,
  setSearchKeyword,
  setOnSearch,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
}) {
  const [rows, setRows] = useState(tasks);
  const navigate = useNavigate();
  const [createdBy, setCreatedBy] = useState(null);
  const [associatedJob, setAssociatedJob] = useState(null);
  const [deadline, setDeadline] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");

  // for updating status
  const [modalOpen, setModalOpen] = useState(false);
  const [status, setStatus] = useState("");

  const [taskId, setTaskId] = useState("");

  const onModalClose = () => {
    setModalOpen(false);
    setStatus("");
    setTaskId("");
  };

  const onModalOpen = (status, taskId) => {
    setStatus(status);
    setTaskId(taskId);
    setModalOpen(true);
  };

  const headCells = [
    // { key: "sno", alignment: "left", label: "S.NO" },
    { key: "title", alignment: "left", label: "Title" },
    { key: "created_by", alignment: "left", label: "Created By" },
    { key: "assigned_to", alignment: "left", label: "Assigned To" },
    { key: "status", alignment: "left", label: "Status" },
    { key: "associated_job", alignment: "left", label: "Associated Job" },
    { key: "deadline", alignment: "left", label: "Deadline" },
    { key: "view", alignment: "center", label: "View" },
    { key: "edit", alignment: "center", label: "Edit" },
  ];

  useEffect(() => {
    if (filteredData) {
      setCreatedBy(filteredData.createdBy);
      setAssociatedJob(filteredData.associatedJob);
      setDeadline(filteredData.deadline);
      setFilterStatus(filteredData.status);
    }
  }, [filteredData]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              style={{
                minHeight: "calc(100vh - 410px)",
              }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setOnSearch(true);
                }}
              >
                <Toolbar>
                  <ToolbarTitle>
                    <Typography variant="h6" id="tableTitle">
                      Tasks
                    </Typography>
                  </ToolbarTitle>
                  <Spacer />

                  <TextField
                    autoFocus
                    value={searchKeyword}
                    size="small"
                    style={{ width: "100%", marginRight: 10 }}
                    label="Search "
                    placeholder="Search by title"
                    onChange={(e) => {
                      setSearchKeyword(e.target.value);
                    }}
                  />

                  <Button
                    endIcon={<SearchIcon />}
                    style={{ width: "20%" }}
                    variant="contained"
                    type="submit"
                  >
                    Search
                  </Button>

                  <div>
                    <AssignedTasksFilter
                      createdBy={createdBy}
                      associatedJob={associatedJob}
                      setAssociatedJob={setAssociatedJob}
                      jobs={jobs}
                      apUsers={apUsers}
                      setCreatedBy={setCreatedBy}
                      deadline={deadline}
                      setDeadline={setDeadline}
                      status={filterStatus}
                      setStatus={setFilterStatus}
                      onFilter={() =>
                        setFilter(
                          null,
                          createdBy,
                          associatedJob,
                          filterStatus,
                          deadline
                        )
                      }
                    />
                  </div>
                  <Tooltip title="Create Task">
                    <IconButton
                      onClick={() => navigate("/dashboard/tasks/create-task")}
                    >
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                </Toolbar>
              </form>
              {rows && rows.length > 0 && (
                <TableContainer>
                  <Table
                    aria-labelledby="tableTitle"
                    size={"small"}
                    aria-label="enhanced table"
                  >
                    <TableHead sx={{ ":root": { backgroundColor: "white" } }}>
                      <TableRow>
                        {headCells.map((h) => {
                          return (
                            <TableCell key={h.key} align={h.alignment}>
                              {h.label}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((task, index) => {
                        return (
                          <TableRow key={index}>
                            {/* <TableCell>{index + 1}</TableCell> */}
                            <TableCell>{task.title}</TableCell>
                            <TableCell>{task.created_by?.name}</TableCell>
                            <TableCell>{task.assigned_to?.name}</TableCell>
                            <TableCell>
                              <Chip
                                size="small"
                                onClick={() =>
                                  onModalOpen(task.status, task._id)
                                }
                                label={task.status.toUpperCase()}
                                style={{
                                  backgroundColor:
                                    task.status === "new"
                                      ? "#87CEEB"
                                      : task.status === "progress"
                                      ? "orange"
                                      : task.status === "submit"
                                      ? "#33B897"
                                      : "#aaa",
                                  color: "#fff",
                                }}
                              />
                            </TableCell>
                            <TableCell>{task.associated_job?.job_id}</TableCell>
                            <TableCell>
                              <Typography
                                color={
                                  moment(new Date()).isAfter(
                                    moment(task.deadline)
                                  ) &&
                                  ["new", "progress"].includes(task.status) &&
                                  "tomato"
                                }
                              >
                                {task.deadline
                                  ? moment(task.deadline)
                                      .utc()
                                      .local()
                                      .format("MMM DD, YYYY h:mm A")
                                  : ""}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <VisibilityIcon
                                style={{ cursor: "pointer", color: "green" }}
                                onClick={() =>
                                  navigate(`/dashboard/tasks/${task._id}`)
                                }
                              />
                            </TableCell>
                            {task.status !== "close" && (
                              <TableCell align="center">
                                <EditIcon
                                  style={{ cursor: "pointer", color: "red" }}
                                  onClick={() =>
                                    navigate(
                                      `/dashboard/tasks/update-task/${task._id}`
                                    )
                                  }
                                />
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              {rows && rows.length > 0 && (
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={total_results}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}

              {(!rows || rows.length === 0) && (
                <Box
                  style={{
                    minHeight: "calc(100vh - 473px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ fontSize: 18 }}>
                    No new tasks available. 📗
                  </Typography>
                </Box>
              )}
            </TableContainer>
          </Grid>
        </Grid>

        <Modal open={modalOpen} onClose={onModalClose}>
          <Card sx={modalStyle} style={{ width: "500px" }}>
            <CardContent>
              <Paper>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="status">Update Status</InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="status"
                        label="Select Status"
                        onChange={(e) => setStatus(e.target.value)}
                        value={status}
                      >
                        <MenuItem disabled value={""}>
                          Update Status To
                        </MenuItem>

                        <MenuItem value={"new"} disabled>
                          NEW
                        </MenuItem>

                        <MenuItem value={"progress"}>IN-PROGRESS</MenuItem>

                        {/* <MenuItem value={"submit"}>SUBMIT</MenuItem> */}

                        <MenuItem value={"close"}>CLOSED</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <Button onClick={onModalClose} color="error">
                      Close
                    </Button>
                  </Grid>
                  <Grid
                    container
                    justifyContent={"flex-end"}
                    item
                    xs={12}
                    md={6}
                    lg={6}
                  >
                    <Button
                      onClick={() => onUpdateStatus(status, taskId)}
                      color="success"
                    >
                      Update Status
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </Modal>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(AllTasks);
